<div class="row new-project-body" [class.editForm]="true">
    <div class="container-fluid" [formGroup]="form">
        <div class="row mt-4 mb-4">
            <div class="form-group col-lg-12">
                <label>{{'order.budget.project.projects' | translate}} *</label>

                <div class="col-lg-12">
                    <div ngbDropdown placement="bottom-left">
                        <div>
                            <form autocomplete="off">
                                <img *ngIf="integrated !== undefined && integrated" class="lock-icon inputed-lock"
                                    src='assets/ico/lock-solid.svg' alt="integrated flag" />
                                <img *ngIf="integrated !== undefined && !integrated" class="lock-open-icon inputed-lock"
                                    src='assets/ico/lock-open-solid.svg' alt="integrated flag" />
                                <input class="search-input form-control" type="text" name="quick-search"
                                    id="quick-search" [placeholder]="'buttons.projectSearch' | translate"
                                    [(ngModel)]="searchValue"
                                    (ngModelChange)="isLoading=true; result=[]; form.reset(); this.quickSearch.next({ value: $event })">
                            </form>
                            <div *ngIf="isLoading && searchValue.length > 0" class="ng-spinner-loader"></div>
                            <div ngbDropdownMenu aria-labelledby="quick-search"
                                [ngClass]="!projectSelected && searchValue.length > 0 ? 'show' : ''"
                                class="scrollable-menu" role="menu" placement="bottom-left" style="width: max-content;">
                                <div ngbDropdownItem *ngFor="let res of result">
                                    <div class="menu-button" (click)="selectProject(res)">
                                        <img *ngIf="res.integrated" class="lock-icon" src='assets/ico/lock-solid.svg'
                                            alt="integrated flag" />
                                        <img *ngIf="!res.integrated" class="lock-open-icon"
                                            src='assets/ico/lock-open-solid.svg' alt="integrated flag" />
                                        <div class="data-row" [innerHTML]="constructDisplayName(res)">
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="result.length === 0 && !isLoading && !projectSelected" ngbDropdownItem>
                                    <div class="row menu-button">
                                        {{'buttons.noResults' | translate}}
                                    </div>
                                </div>
                            </div>
                            <button class="btn closeSearch" (click)="closeSearch()">
                                <div [inlineSVG]="'assets/ico/clear-button.svg'"
                                    class="icon icon-black clear-search-icon" alt="clear"></div>
                            </button>
                        </div>
                    </div>
                </div>
                <label *ngIf="setDefaultBudget" class="mt-3" style="padding-bottom: 30px;">{{'order.budget.project.defaultBudget' | translate}} <apc-help-icon
                    [text]="'buttons.help.helpBudget'"></apc-help-icon></label>
                <div *ngIf="setDefaultBudget" class="form-group col-lg-4 default-budget">
                    <apc-ui-switch formControlName="defaultBudget"></apc-ui-switch>
                </div>

            </div>
        </div>
        <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
                <span *ngIf="form.value.project && form.value.project.integrated" class="btn modal-btn save"
                    (click)="linkProject()">
                    {{'buttons.linkProject' | translate}}</span>
                <span *ngIf="!form.value.project" class="btn modal-btn save disabled" (click)="linkProject()">
                    {{'buttons.linkProject' | translate}}</span>
                <app-modal-info *ngIf="form.value.project && !form.value.project.integrated" title="Confirm action"
                    [text]="'Project <b>' + form.value.project.name + '</b> is currently not integrated with the system. <br/> Would you like to import it?'"
                    color="blue" isQuestion="false" [overlayTop]="true" iconSrc="assets/ico/trash-alt-regular.svg"
                    (confirmEvent)="linkProject()">
                    <span action>
                        <span class="btn modal-btn save">{{'buttons.linkProject' | translate}}</span>
                    </span>
                </app-modal-info>
                <span class="btn modal-btn save back" (click)="cancel()">{{'buttons.back' | translate }}</span>
            </div>
        </div>
    </div>
</div>